

export enum UnitSystem {
    SI = 'si',
    Imperial = 'imperial',
}

export type UnitType = 'weight' | 'height' | 'neck'; 

export type UnitSystemValue = {
  value: number;
  system: UnitSystem;
};

export type UnitTypeValueKey<T extends UnitType> = `${T}`;
export type UnitTypeSystemKey<T extends UnitType> = `${T}System`;